import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.slim = new SlimSelect({
      select: this.selectTarget,
      settings: {
        placeholderText: "Select an option",
        allowDeselect: true
      }
    })
  }

  disconnect() {
    if (this.slim) this.slim.destroy()
  }
}
